module.exports = __webpack_public_path__ + "static/pm2-1fdc8097750b6595463a152657ffaec4.png";